import React, { FC } from 'react';
import { BROWSER_BREAKPOINTS, FilesView, Typography } from '@flicent/fieldpulse-react-component-library-frontend';
import styled from 'styled-components';

import JobFilesProps from './JobFiles.props';


const StyledRoot = styled.div`
  display: grid;
  grid-row-gap: 30px;

  @media screen and ${ BROWSER_BREAKPOINTS.MOBILE } {
    grid-row-gap: 16px;
  }
`;

const JobFiles: FC<JobFilesProps> = ({ job }) => {
  if (!job.is_files_visible || !job.files.length) {
    return null;
  }

  return (
    <StyledRoot>
      <Typography variant="h1">Files</Typography>

      <FilesView size={ job.file_size } files={ job.files }/>
    </StyledRoot>
  );
};


export default JobFiles;